<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proyectos</li>
                <li class="breadcrumb-item active" aria-current="page">Pendientes por publicar</li>
            </ol>
        </nav>
        <projects-list-custom title="Pendientes por publicar" :projectStatus="4" dateToConsult="credit_acceptance_date" :filters="filters" variant="approved"/>
        <approve-list-modal ref="approveListModalComp"/>
    </div>
</template>

<script>
    import ProjectsListCustom from "../../../components/ProjectRequestsListCustom";
    let ApproveListModal = require('../../../components/admin/approveListModal').default;

    export default {
        name: "ProjectsPendingToPublicate",
        components: {
            ProjectsListCustom,
            ApproveListModal
        },
        data: () => ({
            filters: {
                'projects.status': [4],
                resolution_date: null
            }
        }),
        methods:{
            // showApproveModal(e) {
            //     this.$refs["approveListModalComp"].show(e.id)
            // }
            //TO DO
        }
    }
</script>

<style scoped>

</style>